import React, { useState } from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import Swal from "sweetalert2";
import { Popconfirm } from "antd";
import {
  useAdjustWaitingTimeMutation,
  useAdjustWTROTAWaitingTimeMutation,
} from "AppQuries/attendance/waiting-time-adjustment";
import { toast } from "core/Operations/toast";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
const Summary = ({
  fetchedTimeLogData,
  selectedRow,
  attendance,
  onApprove,
  // hasApproved,
  // hasReviewed,
  waitingTimeHandler,
}) => {
  const userData = useSelector(loggedInUser);
  const { watch } = useFormContext();
  const approveTimeLog = () => {
    Swal.fire({
      title: "Confirm to Approve?",
      text: "Are you sure to confirm of this timesheet is approved",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
      buttons: ["Cancel", "Submit"],
    }).then(function (t) {
      if (t.isConfirmed) {
        const selectedEmployees = attendance.filter((a) =>
          selectedRow.includes(a.id),
        );

        const isValid = selectedEmployees?.every((obj) => !obj.hasOutTime);

        if (isValid) {
          Swal.fire({
            title: "Warning!",
            text: "Something went wrong. Please try again",
            type: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
            confirmButtonClass: "btn btn-primary",
            okButtonClass: "",
            buttonsStyling: 1,
          });
          return;
        }

        const updatedData = selectedEmployees?.map((s) => ({
          ...s,
          slno: s.slno !== null ? s.slno : 0,
          slNo: s.slno !== null ? s.slno : 0,
          companyCode: s.companyCode,
          locationCode: s.locationCode,
          employeeCode: s.employeeCode,
          attendanceValue: Number(s.attendanceValue),
          attendanceDate: s.attendanceDate,
          inTime: s.inTime,
          outTime: s.outTime,
          totalWorkingHours: s.totalWorkingHours || 0,
          createUser: s.createUser || watch("userName"),
          createDate: s.createDate || getCurrentFormattedDate(),
          modifyUser: watch("userName"),
          modifyDate: getCurrentFormattedDate(),
          scheduleId: s.scheduleId || 0,
          projectCode: s.projectCode || "",
          shiftId: s.shiftId || "",
          remarks: s.remarks || "",
          mode: s.mode || "",
          waitingTime: s.waitingTime || "00:00:00",
          wtrot: s.wtrot || "00:00:00",
          isApproved: true,
          oT1: s.oT1 || 0,
          oT2: s.oT2 || 0,
          extraCharge: s.extraCharge || 0,
          wtnhEdit: s.wtnhEdit || false,
          supplierCompany: s.supplierCompany || "",
          service: s.service || "",
          isReviewed: s.isReviewed || true,
          reviewDate: s.reviewDate || getCurrentFormattedDate(),
          reviewBy: s.reviewBy ||  watch("userName"),
          approvedDate: getCurrentFormattedDate(),
          approvedBy: watch("userName"),
          normalHours: s?.normalWorkingHours || 0,
          hasOutTime: s?.hasOutTime || true,
        }));

        onApprove(updatedData);
      }
    });
  };
  const reviewTimeLog = () => {
    Swal.fire({
      title: "Confirm to Reviewed?",
      text: "Are you sure to confirm of this timesheet is reviewed",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
      buttons: ["Cancel", "Submit"],
    }).then(function (t) {
      if (t.isConfirmed) {
        const selectedEmployees = attendance.filter((a) =>
          selectedRow.includes(a.id),
        );
        const updatedData = selectedEmployees?.map((s) => ({
          ...s,
          slno: s.slno !== null ? s.slno : 0,
          slNo: s.slno !== null ? s.slno : 0,
          companyCode: s.companyCode,
          locationCode: s.locationCode,
          employeeCode: s.employeeCode,
          attendanceValue: Number(s.attendanceValue),
          attendanceDate: s.attendanceDate,
          inTime: s.inTime,
          outTime: s.outTime,
          totalWorkingHours: s.totalWorkingHours || 0,
          createUser: s.createUser || watch("userName"),
          createDate: s.createDate || getCurrentFormattedDate(),
          modifyUser: watch("userName"),
          modifyDate: getCurrentFormattedDate(),
          scheduleId: s.scheduleId || 0,
          projectCode: s.projectCode || "",
          shiftId: s.shiftId || "",
          remarks: s.remarks || "",
          mode: s.mode || "",
          waitingTime: s.waitingTime || "00:00:00",
          wtrot: s.wtrot || "00:00:00",
          isApproved: s.isApproved || false,
          oT1: s.oT1 || 0,
          oT2: s.oT2 || 0,
          extraCharge: s.extraCharge || 0,
          wtnhEdit: s.wtnhEdit || false,
          supplierCompany: s.supplierCompany || "",
          service: s.service || "",
          approvedDate: s.approvedDate,
          approvedBy: s.approvedBy,
          isReviewed: true,
          reviewDate: getCurrentFormattedDate(),
          reviewBy: watch("userName"),
          normalHours: s?.normalWorkingHours || 0,
          hasOutTime: s?.hasOutTime || true,
          isAlternateDayOff: s?.isAlternateDayOff,
          isHalfDay: s?.isHalfDay,
        }));

        onApprove(updatedData);
      }
    });
  };

  return (
    <div className="row mb-3">
      <div className="col-md-3">
        {selectedRow.length > 0 && (
          <div className="row mb-3">
            <button
              className="btn btn-secondary btn-success"
              onClick={approveTimeLog}
              // disabled={!hasReviewed}
            >
              Approve
            </button>
            &nbsp;
            <button
              className="btn btn-secondary"
              onClick={reviewTimeLog}
              // disabled={hasReviewed}
            >
              Review
            </button>
          </div>
        )}
        <div className="table-responsive mb-3">
          <table className="timelog-summary-leave">
            <thead>
              <tr>
                <th>Total Working Days</th>
                <th>
                  {
                    fetchedTimeLogData?.timeLogSummary?.[0]
                      ?.totalWorkingDaysinMonth
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Public Holiday</td>
                <td>
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.publicHolidays}
                </td>
              </tr>
              <tr>
                <td>Worked Days</td>
                <td>
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.totalWorkedDays}
                </td>
              </tr>
              <tr>
                <td>Payable Working Days</td>
                <td>
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.payableworkingDays}
                </td>
              </tr>

              <tr>
                <td>Total Rest Days</td>
                <td>
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.totalRestDays}
                </td>
              </tr>
              <tr>
                <td>Rest Working Days</td>
                <td>
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.restWorkingDays}
                </td>
              </tr>
              <tr>
                <td>Public Holiday Working Days</td>
                <td>
                  {
                    fetchedTimeLogData?.timeLogSummary?.[0]
                      ?.publicHolidayWorkingDays
                  }
                </td>
              </tr>
              <tr>
                <td>Total Night Shifts</td>

                <td>
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.totalNightShift}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="table-responsive">
          {fetchedTimeLogData?.leaveDetails?.length > 0 && (
            <table className="timelog-summary-leave">
              <tr>
                <th colSpan={4}>Leave Days</th>
              </tr>
              <tr>
                <th>Type</th>
                <th>Applied</th>
                <th>Paid</th>
                <th>Un Paid</th>
              </tr>
              {fetchedTimeLogData?.leaveDetails?.map((leave, index) => (
                <tr key={index}>
                  <td>{leave.leaveName}</td>
                  <td>{leave.isApproved}</td>
                  <td>{leave.paidLeave}</td>
                  <td>{leave.unPaidLeave}</td>
                </tr>
              ))}
            </table>
          )}
        </div>
      </div>
      <div className="col-md-3">
        <div className="table-responsive mb-3">
          <table className="timelog-summary-leave" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th colSpan={2}>Leave Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left">Total Absent Days</td>

                <td className="text-right">
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.totalAbsentDays}
                </td>
              </tr>
              <tr>
                <td className="text-left">Total Applied Leave</td>

                <td className="text-right">
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.totalAppliedLeave}
                </td>
              </tr>

              <tr>
                <td className="text-left">Total Paid Days</td>
                <td className="text-right">
                  {fetchedTimeLogData?.timeLogSummary?.[0]?.totalPaidLeaveDays}
                </td>
              </tr>

              <tr>
                <td className="text-left">Total Un Paid Days</td>
                <td className="text-right">
                  {
                    fetchedTimeLogData?.timeLogSummary?.[0]
                      ?.totalUnPaidLeaveDays
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="table-responsive ">
          <table className="timelog-summary-leave">
            <thead>
              <tr>
                <th colSpan={6}>Waiting Time</th>
              </tr>
              <tr>
                <th>NH</th>
                <th>OT1</th>
                <th>OT2</th>
                <th>WT</th>

                <th>Total</th>
                <th>ROT</th>
                <th>Max OT</th>
              </tr>
            </thead>
            <tbody>
              {fetchedTimeLogData?.waitingSummary?.map((wt, _idx) => {
                if (wt) {
                  return wt.map((w, _idx) => {
                    if (w) {
                      return (
                        <tr key={_idx}>
                          <td>{w.normarWorkingHours}</td>
                          <td>{w.oT1}</td>
                          <td>{w.oT2}</td>
                          <td>{w.waitingTime}</td>
                          <td>{w.totalHours}</td>
                          <td>{w.restDayOTHours}</td>
                          <td>{w.maxOT}</td>
                        </tr>
                      );
                    }
                  });
                }
              })}
            </tbody>
          </table>
        </div>
        {userData?.adjustWaitingTime && (
          <div className="d-flex justify-content-space-between  m-3">
            <Popconfirm
              title="Adjust Waiting Time?"
              description="Really want Adjust Waiting Time ?"
              // icon={<BookOpen className="me-2" />}
              // onConfirm={() => }
              onConfirm={() => waitingTimeHandler("NOT")}
              onCancel={() => console.log("Cancel")}
              okText="Yes"
              cancelText="No"
            >
              <button
                type="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
              >
                Adjust Waiting Time / OT
              </button>
            </Popconfirm>
            &nbsp;
            <Popconfirm
              title="Adjust WTROT Waiting Time?"
              description="Really want Adjust  WTROT Waiting Time ?"
              // icon={<BookOpen className="me-2" />}
              // onConfirm={() => }
              onConfirm={() => waitingTimeHandler("WTROT")}
              onCancel={() => console.log("Cancel")}
              okText="Yes"
              cancelText="No"
            >
              <button
                type="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
              >
                Adjust WTROT Waiting Time
              </button>
            </Popconfirm>
          </div>
        )}
      </div>
      <div className="col-md-4">
        <div className="table-responsive mb-3">
          <table className="timelog-summary-leave">
            <thead>
              {/* <tr>
                <th colSpan={7}>Hours</th>
                <th>Mins</th>
              </tr> */}
              <tr>
                <th>NH</th>
                <th>OT1</th>
                <th>OT2</th>
                <th>Total</th>
                <th>Worked</th>
                <th>ROT</th>
                <th>Late</th>
              </tr>
            </thead>
            <tbody>
              {fetchedTimeLogData?.workingSummary?.map((ws, _idx) => {
                if (ws) {
                  return ws.map((w, _idx) => {
                    if (w) {
                      return (
                        <tr key={_idx}>
                          <td>{w.normarWorkingHours}</td>
                          <td>{w.oT1}</td>
                          <td>{w.oT2}</td>
                          <td>{w.totalHours}</td>
                          <td>{w.totalWorkedHours}</td>
                          <td>{w.restDayOTHours}</td>
                          <td>{w.totalLateHours}</td>
                        </tr>
                      );
                    }
                  });
                }
              })}
              {fetchedTimeLogData?.totalSummary?.length > 0 &&
                fetchedTimeLogData?.totalSummary?.map((ts, _idx) => (
                  <tr key={_idx}>
                    <td>{Number(ts.normarWorkingHours).toFixed(2)}</td>
                    <td>{Number(ts.oT1).toFixed(2)}</td>
                    <td>{Number(ts.oT2).toFixed(2)}</td>
                    <td>{Number(ts.totalHours).toFixed(2)}</td>
                    <td>{Number(ts.totalWorkedHours).toFixed(2) || 0.0}</td>
                    <td>{Number(ts.restDayOTHours).toFixed(2) || 0.0}</td>
                    <td>{Number(ts.totalLateHours).toFixed(2) || 0.0}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="table-responsive">
          <table className="timelog-summary-leave">
            <thead>
              <tr>
                <th>Project</th>
                <th>NH</th>
                <th>OT1</th>
                <th>OT2</th>
              </tr>
            </thead>
            <tbody>
              {fetchedTimeLogData?.employeeProjectWorkingHours?.map(
                (w, _idx) => {
                  if (w) {
                    if (w) {
                      return (
                        <tr key={_idx}>
                          <td>{w.projectName}</td>
                          <td>{w.normalWorkingHours}</td>
                          <td>{w.totalOT1}</td>
                          <td>{w.totalOT2}</td>
                        </tr>
                      );
                    }
                  }
                },
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-md-2">
        {fetchedTimeLogData?.attendanceDetails?.every(
          (obj) => obj.isReviewed && obj.isApproved,
        ) ? (
          <>
            <div className="approved text-center">
              <span>Approved</span>
            </div>
            <span>
              Approved By :
              {fetchedTimeLogData?.attendanceDetails?.[0]?.approvedBy}
            </span>
            <br />
            <span>
              Approved Date :
              {fetchedTimeLogData?.attendanceDetails?.[0]?.approvedDate}
            </span>
          </>
        ) : fetchedTimeLogData?.attendanceDetails?.every(
            (obj) => obj.isApproved,
          ) ? (
          <>
            <div className="approved text-center">
              <span>Approved</span>
            </div>
            <span>
              Approved By :
              {fetchedTimeLogData?.attendanceDetails?.[0]?.approvedBy}
            </span>
            <span>
              Approved Date :
              {fetchedTimeLogData?.attendanceDetails?.[0]?.approvedDate}
            </span>
          </>
        ) : (
          <div className="un-approved text-center">
            <span>Not Approved</span>
          </div>
        )}
        {/* // ) : (
        //   <div className="un-approved">
        //     <span>Invalid</span>
        //   </div>
        // )} */}
      </div>
    </div>
  );
};

export default React.memo(Summary);
Summary.propTypes = {
  fetchedTimeLogData: PropTypes.object.isRequired,
  selectedRow: PropTypes.array.isRequired,
  attendance: PropTypes.array.isRequired,
  onApprove: PropTypes.func.isRequired,
  // hasApproved: PropTypes.bool.isRequired,
  // hasReviewed: PropTypes.bool.isRequired,
  waitingTimeHandler: PropTypes.func.isRequired,
};
